import * as React from "react";
import Select from 'react-select';
import {PlaceholderProps} from "../../../../common/props/PlaceholderProps";
import {ActionMeta} from "react-select/lib/types";
import MerchantBranchLocation from "../../../../../model/merchant/MerchantBranchLocation";
import {SitesMap} from "../../../../../store/reducer/site/SiteState";
import PartnerBrand from "../../../../../model/partnerBrand/PartnerBrand";
import Loading from "../../../../ui/loading/Loading";
import classNames = require("classnames");
import {Option} from "ts-option";
import {Option as SelectOption} from "react-select/lib/filters";

interface ComponentProps {
	/**
	 * On select action
	 */
	onSelect: (location: any) => void;
	/**
	 * Initial search query text.
	 */
	initialSearchQuery?: Option<string>
	/**
	 * Locations available for user selection.
	 */
	locations: MerchantBranchLocation[];
	/**
	 * Input value
	 */
	value: Option<MerchantBranchLocation>
	/**
	 * Sites
	 */
	sites: SitesMap,
	/**
	 * Partner brand
	 */
	partnerBrand: Option<PartnerBrand>
}

type Props = ComponentProps & PlaceholderProps;

export default class BranchLocationDropdown extends React.PureComponent<Props> {

	constructor(props: Props) {
		super(props);
		this.renderNoOptionsMessage = this.renderNoOptionsMessage.bind(this);
		this.renderOptionComponent = this.renderOptionComponent.bind(this);
	}

	render() {
		return (
			<Select
				classNamePrefix={"c-select-component"}
				value={this.props.value.orNull}
				styles={{menuList: (base) => ({...base, maxHeight: "186px"})}}
				placeholder={this.props.placeholder}
				components={{
					Option: this.renderOptionComponent,
					Menu: this.renderMenuComponent,
					NoOptionsMessage: this.renderNoOptionsMessage,
					SingleValue: this.renderOptionComponent
				}}
				options={this.props.locations}
				onChange={this.onSelected}
				closeMenuOnSelect={true}
				openMenuOnFocus={true}
				filterOption={this.filterLocation}/>
		)
	}

	renderAddress = (siteId: string) => {
		return this.props.sites[siteId] ? this.props.sites[siteId].data.address.displayStreet() :
			<Loading isLoading={true} spinnerSize={24}/>;
	};


	/**
	 * Render option component (select dropdown list element)
	 * @param props properties for list element.
	 */
	renderOptionComponent(props: any): JSX.Element {
		const {innerProps, innerRef, isFocused, data, className} = props;
		const classFromProps = classNames(
			{
				"c-selection-bom-modal_select-option-component": true,
				"has-focus": isFocused
			},
			className
		);
		return (
			<div ref={innerRef} className={classFromProps} {...innerProps}>
				<div className="c-selection-bom-modal_select-option-component">
					<div className="c-selection-bom-modal_select-option-component_labels">
						<div>
							<span className="c-selection-bom-modal_select-option-component_labels_column">
								<b className="c-selection-bom-modal_select-option-component_labels_blue-color">
									{data.name}</b> {this.renderAddress(data.siteId)}
							</span>
						</div>
						{data.id === this.props.partnerBrand.map(pb => pb.preferredMerchantBranchLocationId) &&
						<div className="c-selection-bom-modal_select-option-component_labels_badge fit-content">
							<span><b>Preferred</b></span>
						</div>
						}
					</div>
				</div>
			</div>
		)
	}

	/**
	 * Render menu component (wrapper for the dropdown menu in the select)
	 * @param props properties for list element.
	 */
	renderMenuComponent(props: any): JSX.Element {
		const {innerProps, innerRef, className} = props;
		const classFromProps = classNames(
			{
				"bom-selection": true
			},
			className
		);
		return (
			<div ref={innerRef} className={classFromProps} {...innerProps}>
				<div className={'selection-header'}>
					{props.children}
				</div>
			</div>
		);
	}

	/**
	 * Render no options component (Message to be displayed in the menu if there are no options passed in)
	 */
	renderNoOptionsMessage(): JSX.Element {
		return <div className="no-option">Type to search</div>;
	}

	filterLocation = (locations: SelectOption, queryText: string) => {
		return  locations.data.name.toLowerCase().indexOf(queryText.toLowerCase()) !== -1
	}

	/**
	 * Callback on selected item.
	 * @param {MerchantBranchLocation} selected item.
	 * @param {ActionMeta} actionMeta performed action data.
	 */
	onSelected = (selected: MerchantBranchLocation, actionMeta: ActionMeta) => {
		if (actionMeta.action === 'clear') {
			this.setState({queryText: ""});
		}
		// compare with array is fix for https://github.com/JedWatson/react-select/issues/2682
		else if (!(selected instanceof Array)) { //
			this.props.onSelect(selected);
		}
	};
}
